import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { REQUEST_ACTIONS } from '../../../Constants/Actions.constants';
import { Route } from '../../../Constants/Routes.constants';
import { useLanguage } from '../../../Hooks/useLanguage';
import { useNavigation, Navigate } from '../../../Hooks/useNavigation';
import { selectPasswordRecovery } from '../../../store/auth';
import PasswordResetSuccesComponent from './PasswordResetSuccess.component';

export const goBack = (navigate: Navigate) => () => navigate(Route.LOGIN);

export const usePasswordResetSuccess = () => {
  const { t } = useLanguage();
  const newPasswordRequestSuccess = useSelector(
    selectPasswordRecovery(REQUEST_ACTIONS.NEW_PASSWORD),
  );
  const { navigate } = useNavigation();
  return {
    t,
    newPasswordRequestSuccess,
    backToLogin: goBack(navigate),
  };
};

const PasswordResetSuccessContainer = () => {
  const { t, backToLogin, newPasswordRequestSuccess } = usePasswordResetSuccess();

  return (
    <>
      {!newPasswordRequestSuccess && <Redirect to={Route.LOGIN} />}
      <PasswordResetSuccesComponent handleBackToLogin={backToLogin} t={t} />
    </>
  );
};

export default PasswordResetSuccessContainer;
